<template>
    <div>
      <component
        v-if="field"
        :is="field.component"
        :ref="field.id"
        :id="field.id"
        :props="field"
        :disabled="disabled"
        @update="update"
      ></component>
    </div>
  </template>
    
    
  <style lang="scss">
    @import "@/sass/explorer.scss";
    @import "@/sass/modalform.scss";
  </style>
    
    
  <script>
    import { QFilters, get_qfilter, QFilterCustom } from '@/qunit/filters';
    import TextInput from '@/components/inputs/TextInput'
    import Select from '@/components/inputs/Select'
    import DateInput from '@/components/inputs/DateInput'
    import DateTimeInput from '@/components/inputs/DateTimeInput'
    import TextareaInput from '@/components/inputs/TextareaInput'
    import NumericInput from '@/components/inputs/NumericInput'
    import FileInput from '@/components/inputs/FileInput'
    import ProcessDependingUserField from '@/components/inputs/ProcessDependingUserField'
    import DirectoryInput from '@/components/inputs/DirectoryInput'
    import Tag from '@/components/inputs/Tag'
    import AutocompleteSelect from '@/components/inputs/AutocompleteSelect'
    import DynamicSelectInput from '@/components/inputs/DynamicSelectInput'
    import DynamicInput from '@/components/inputs/DynamicInput'
    import TimeEvent from '@/components/inputs/TimeEvent'
    import ComputedInput from '@/components/inputs/ComputedInput'
    import StateInput from '@/components/inputs/StateInput';
    import CheckboxInput from '@/components/inputs/CheckboxInput'
    import TreeviewSelect from '@/components/inputs/TreeviewSelect'
    import IndicatorMetricInput from '@/components/inputs/IndicatorMetricInput';
    import IndicatorTrackingInput from '@/components/inputs/IndicatorTrackingInput';
    import RelatedSelect from '@/components/inputs/RelatedSelect'
    import MetricEdit from '@/components/inputs/MetricEdit';
    export default {
      components: {
        TextInput,
        Select,
        DateInput,
        DateTimeInput,
        TextareaInput,
        NumericInput,
        FileInput,
        ProcessDependingUserField,
        DirectoryInput,
        Tag,
        AutocompleteSelect,
        DynamicSelectInput,
        DynamicInput,
        TimeEvent,
        ComputedInput,
        StateInput,
        CheckboxInput,
        TreeviewSelect,
        IndicatorMetricInput,
        IndicatorTrackingInput,
        RelatedSelect,
        MetricEdit,
      },
    
      name: 'FilterGeneric',
    
      props: {
        field: {
        },
        disabled: Boolean,
      },
    
      data: () => ({
        value: null,
      }),
    
      computed: {
      },
    
      mounted() {
      },
    
      methods: {
        update(value) {
          this.value = value
          this.$emit('update',get_qfilter(this.field.id,value))
        },
      },

      watch: {
      },
    }
  </script>
    